import { FC, ReactNode } from 'react';
import { Box, Paper, Stack, Typography } from '@mui/material';

type EmptyListPropsType = {
  text?: ReactNode;
  title?: ReactNode;
  action?: ReactNode;
};

export const EmptyList: FC<EmptyListPropsType> = ({ text, title, action }) => {
  return (
    <Paper
      elevation={0}
      sx={{
        width: '100%',
        p: { xs: 4, sm: 5, md: 6 },
        border: (theme) => `1px solid ${theme.palette.hairline}`,
      }}
      component={Stack}
      rowGap={2}
      alignItems="center"
      justifyContent="center"
    >
      <Box
        component="img"
        src={process.env.PUBLIC_URL + '/icons/empty-list.png'}
        alt=""
        sx={{ maxWidth: 160, width: '40%', opacity: 0.9 }}
      />
      {title && (
        <Typography variant="h6" fontWeight={600} align="center">
          {title}
        </Typography>
      )}
      {text && (
        <Typography
          align="center"
          color="text.secondary"
          sx={{ maxWidth: 420 }}
        >
          {text}
        </Typography>
      )}
      {action && <Box sx={{ mt: 1 }}>{action}</Box>}
    </Paper>
  );
};
